var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SOModalExport',{attrs:{"is-running":_vm.isExporting,"context":'Ekspor',"total-data":`${_vm.totalPembayaranEdc} Pembayaran`,"export-data-exist":_vm.data.length > 0 ? _vm.data.filter((v) => v.downloaded === false).length : 0},on:{"close":_vm.closeModal,"do-export":_vm.doExport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }